import { render, staticRenderFns } from "./GroupAdd.vue?vue&type=template&id=282a072b&scoped=true&"
import script from "./GroupAdd.vue?vue&type=script&lang=js&"
export * from "./GroupAdd.vue?vue&type=script&lang=js&"
import style0 from "./GroupAdd.vue?vue&type=style&index=0&id=282a072b&scoped=true&lang=css&"
import style1 from "./GroupAdd.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282a072b",
  null
  
)

export default component.exports
import {QLayout,QPageContainer,QPage,QCardSection,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QPageContainer,QPage,QCardSection,QBtn})
